module.exports = __webpack_public_path__ + "img/renovation.9c06aa14.svg";